import React from "react";
import StowOverview from "../StowOverview";
import StowBreakdown from "../StowBreakdown";
import GridAllocation from "../GridAllocation";
import StowBreakdownV3 from "../StowBreakdownV3";

export const DEFAULT_ROUTES = {
    "/heatMapv2": "/heatMapv2/StowOverview",
};
export const STOW_ROUTES = [{
    name: "Stow-Overview",
    path: "/heatMapv2/StowOverview",
    id:"Overview",
    component: () => {
        return (<StowOverview/>)
    },
}, {
    name: "Stow-Breakdown",
    path: "/heatMapv2/StowBreakdown",
    id:"Stow Breakdown",
    component: () => {
        return (<StowBreakdown/>)
    },
}];

export const STOW_BREAKDOWN_V2_ROUTE ={
    name: "Stow-Breakdown-V2",
    path: "/heatMapv2/StowBreakdownV2",
    id:"Stow Breakdown V2",
    component: () => {
        return (<StowBreakdownV3/>)
    }
}

export const GRID_ALLOCATION_ROUTE = {
    name: "Grid-Allocation",
    path: "/heatMapv2/GridAllocation",
    id:"Grid Allocation",
    component: () => {
        return (<GridAllocation/>)
    },
};



// WEBPACK FOOTER //
// ./src/components/utils/RouteConstants.js